import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    holidaysData: [], 
}

const userHolidaysSlice = createSlice({
  name: "userHolidays",
  initialState: initialState,
  reducers: {
    setUserHolidaysData(state, value) {
      state.holidaysData = value.payload;
    }
  },
});

export const { setUserHolidaysData } = userHolidaysSlice.actions;

export default userHolidaysSlice.reducer;